import { SmartTooltip } from '@sdk/common/tooltip/SmartTooltip';
import gettext from '@sdk/lang/gettext';

import { BorderedButtonContainer } from '@web/timesheets/CreateTimesheetModal/components/buttons/buttons.styles';
import TrashIconSvg from '@web/assets/svg/Icons/34/trash-gray.svg';

type Props = {
  onClick: VoidFunction;
};
const RemoveEntryButton = ({ onClick }: Props) => (
  <BorderedButtonContainer onClick={onClick}>
    <SmartTooltip content={gettext('Delete entry')} place="right">
      <TrashIconSvg />
    </SmartTooltip>
  </BorderedButtonContainer>
);

export default RemoveEntryButton;
